// extracted by mini-css-extract-plugin
export default {"button":"_3V6HM","navigate":"_1pr8C","header":"e-ILy","orderNumber":"_3w3OR","placedOn":"_1iHFw","actions":"cFeTO"};